import React from 'react'
import { Steps } from 'antd'
import { isMobile } from 'react-device-detect';
import MobileStepper from './MobileStepper';

interface StepperProps {
  current: number
}

const steps = [
  {
    title: 'Account Verification',
    icon: 1,
    className: 'max-w-[25%]'
  },
  {
    title: 'Investment Amount',
    icon: 2,
    className: 'max-w-[25%]'
  },
  {
    title: 'Acknowledgement',
    icon: 3,
    className: 'max-w-[25%]'  
  },
  {
    title: 'Payment Selection',
    icon: 4,
    className: 'max-w-[25%]'  
  },
  {
    title: 'Finish',
    icon:  5,
    className: 'max-w-[25%]'
  },
]

const ReInvestStepper = ({ current }: StepperProps) => {
  return (
    !isMobile ?
      <Steps
        direction='horizontal'
        responsive={false}
        labelPlacement={'vertical'}
        current={current - 1}
        items={steps}
      />
      :
      <MobileStepper
        steps={steps}
        current={current - 1}
      />
  )
}

export default ReInvestStepper
